module.exports = __webpack_public_path__ + "img/longshan_pano-min.72facb87.jpg";